import { useEgressIPs } from "@/api/queries/egress-ips.ts";

const EgressIPsInstructions = () => {
  const { data: egressIPs, isLoading, error } = useEgressIPs();

  if (isLoading || !Array.isArray(egressIPs) || !egressIPs) {
    return null;
  }

  if (error) {
    return <p className={"mt-[5px]"}>Error fetching egress IPs: {error.message}</p>;
  }

  const instructions = (
    <p className={"mt-[5px]"}>If network policies are in use, the following IP address(es) must be allowed: </p>
  );

  const ipAddresses = (
    <ul>
      {egressIPs.map((addr, idx) => (
        <li key={idx}>
          <code>{addr}</code>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      {instructions}
      {ipAddresses}
    </>
  );
};

export default EgressIPsInstructions;
